import { api } from '@shared/api/api';

type ParkingRequestData = App.Domain.Parking.Data.ParkingRequestData;

export const deleteParkingRequest = (parkingRequest: ParkingRequestData) =>
  api.delete(`/registrations/${parkingRequest.registrationId}/parking-requests/${parkingRequest.id}`);
